



























import PagePopup from '@/components/popup/page/PagePopup.vue'
import BankCard from '@/components/card/BankCard.vue'
import FooterButton from '@/components/FooterButton.vue'
import Translation from '@/mixins/Translation'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import toCurrency from '@/filters/to-currency'
import DISABLE_PAYMENT_BANK_CODES from '@/constants/disable-payment-bank-codes'
import {Bank} from '@/store/modules/banks/types'
import {LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'

const payment = namespace('payment')
const gtm = namespace('gtm')

interface BankItem extends Bank {
  isPayment?: boolean
  empty?: boolean
  kind: string
}

@Component({
  components: {
    FooterButton,
    PagePopup,
    empty: BankCard,
    bank: BankCard,
  },
  filters: {
    toCurrency,
  },
})
export default class BankAccountSelectionPopup extends Mixins(Translation) {
  @payment.Getter('gtmInfo') gtmInfo
  @gtm.Action('logEventWithGroups') logEventWithGroups:
    (payload: LogEventWidthGroupsPayload) => void

  @Prop({default: 'terms.banks'}) translation: string
  @Prop({default: false}) isOpen: boolean
  @Prop({default: () => ([]), type: Array}) banks: Bank[]
  @Prop({default: 0, type: Number}) totalAmount: number

  selectedBank: string | null = null

  get footerTotalAmount() {
    const {totalAmount, ts} = this
    const register = `${ts('payment')}하기`
    if(totalAmount) {
      return `${toCurrency(totalAmount)}${ts('currency')} ${register}`
    }
    return `${register}`
  }

  get bankList(): BankItem[] | any[] {
    const banks = this.banks.map((bank) => ({
      ...bank,
      kind: 'bank',
      isPayment: !this.isDisableAccount(bank.code) && bank.isWithdrawal
    }))
    return [...banks, {kind: 'empty', empty: true, isPayment: true}]
  }

  get disabledBanksToText(): string {
    const {ts} = this
    return DISABLE_PAYMENT_BANK_CODES.map((code) => `${ts(`bank-codes.${code}`)}${ts('bank')}`).join(', ')
  }

  @Watch('isOpen')
  __isOpen(value) {
    if(value) {
      if(this.banks.length) {
        this.selectBank(this.bankList[0])
      }
      this.logEventWithGroups({
        eventType: 'popup_view',
        eventProperties: {
          ...this.gtmInfo,
          'popup_name': 'select_bank_account',
        }
      })
    }
  }

  selectBank(bank: BankItem) {
    if(this.isDisableAccount(bank.code) || !bank.isWithdrawal || !bank.isPayment) return
    this.selectedBank = bank.id
    this.$emit('select-bank', bank.id)
  }

  isDisableAccount(code) {
    return DISABLE_PAYMENT_BANK_CODES.includes(code)
  }

  selectedColor(bankId) {
    return this.isSelected(bankId) ? 'positive' : null
  }

  isSelected(bankId) {
    return this.selectedBank === bankId
  }

  onClick(bank: BankItem) {
    if(!bank.isPayment) return
    if(bank.kind === 'bank') {
      this.selectBank(bank)
    } else {
      this.$emit('open-type')
    }
  }

  onClickConfirm() {
    this.$emit('confirm-payment')
  }

  onClosePopup() {
    this.$emit('on-after-close')
  }
}
